import type { CartConfig } from '#types/config/components/cart'
import type { RecursivePartial } from '#types/utils'

export default {
  thumbnails: {
    width: { sm: 103 },
    height: { sm: 103 }
  }
} satisfies RecursivePartial<CartConfig['item']>
